import { RentOptionDocument } from 'entities/RentOption';

export interface RentOptionFormDrawerSchema {
  mode: Nullable<DrawerMode>;
  rentOption?: Nullable<RentOptionDocument>;
}

export enum DrawerMode {
  RENT_OPTION_EDIT = 'rent_option_edit',
  RENT_OPTION_CREATE = 'rent_option_create',
}
